import { render, staticRenderFns } from "./svg-check.vue?vue&type=template&id=0e9db5f2&"
import script from "./svg-check.vue?vue&type=script&lang=js&"
export * from "./svg-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports